import axios from "axios";
import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import Api from "../lib/api";
import acpLogoImg from "../acp-logo-2019.color.png";

interface Props {
  type: string;
  applicationId: string;
}

interface DangerouslySetInnerHTML {
  __html: string;
}

interface State {
  loading: boolean;
  thankYouHtml?: DangerouslySetInnerHTML;
}

const api = new Api();

class ThanksPage extends React.Component<RouteComponentProps<Props>, State> {
  constructor(props: RouteComponentProps<Props>) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  async componentDidMount() {
    try {
      const { type, applicationId } = this.props.match.params;

      // Fetch application from API
      const appl = await api.getApplicationById(applicationId);

      // If application doesn't exist, redirect to 404
      if (!appl) {
        this.props.history.replace("/404");
        return;
      }

      // If application hasn't been submitted yet, redirect back to the application
      if (!appl.submittedAt) {
        this.props.history.replace(`/a/${applicationId}`);
        return;
      }

      // Load the appropriate thank you HTML
      await this.loadThankYou(type);
    } catch (e) {
      console.error("Error loading thank you page:", e);
      this.setState(() => {
        throw e;
      });
    }
  }

  private readonly base = "/survey-definitions/";

  // Map URL type parameter to thank you HTML file
  private readonly thankyouPageMap = new Map<string, string>([
    ["mentor", `${this.base}mentor.html`],
    ["veteran", `${this.base}protege.html`],
    ["spouse", `${this.base}protege.html`],
  ]);

  loadThankYou = async (type: string) => {
    const actualPageUrl = this.thankyouPageMap.has(type)
      ? this.thankyouPageMap.get(type)
      : this.thankyouPageMap.get("veteran"); // fallback to protege

    const html = (await axios.get(actualPageUrl!)).data;
    console.info(`Loaded thank you HTML from: ${actualPageUrl}`, { html });

    this.setState({
      thankYouHtml: { __html: html },
      loading: false,
    });
  };

  render() {
    if (this.state.loading) {
      return this.loadingContent();
    }

    if (this.state.thankYouHtml) {
      return <div dangerouslySetInnerHTML={this.state.thankYouHtml} />;
    }

    return null;
  }

  loadingContent() {
    return (
      <div
        style={{
          position: "absolute",
          top: "0",
          left: "0",
          height: "100%",
          width: "100%",
          background: "white",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <style>
          {`
            @keyframes pulse {
              0%, 100% {
                transform: scale(1);
                opacity: 1;
              }
              50% {
                transform: scale(1.05);
                opacity: 0.9;
              }
            }
            .loading-logo {
              animation: pulse 1.5s ease-in-out infinite;
            }
          `}
        </style>
        <img
          src={acpLogoImg}
          alt="Loading"
          className="loading-logo"
          style={{ width: "200px", height: "auto" }}
        />
        <p style={{ marginTop: "20px", color: "#666", fontSize: "14px" }}>
          Loading...
        </p>
      </div>
    );
  }
}

const ThanksPageWithRouter = withRouter(ThanksPage);
export default ThanksPageWithRouter;
